import { createContext, FC, useContext, ReactNode, useMemo } from "react";
import { AppConfig, createAppConfig, emptyConfig, handleValidationError } from "./AppConfig";

const ConfigContext = createContext<AppConfig | undefined>(undefined);

interface ConfigProviderProps {
    children: ReactNode;
}

export const ConfigProvider: FC<ConfigProviderProps> = ({ children }) => {
    const config: AppConfig = useMemo(() => {
        try {
            return createAppConfig();
        } catch (error) {
            console.error("Error creating config:", handleValidationError(error));
            return emptyConfig
        }
    }, []);

    return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): AppConfig => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error("useConfig must be used within a ConfigProvider");
    }
    return context;
};
